<template>
  <div>
    <Button type="info" shape="circle" icon="md-add" style="margin:.5rem 2rem" @click="NewBuildHandleClick">新增</Button>
    <Button type="info" shape="circle" icon="md-add" style="margin:.5rem 2rem" @click="BatchHandleClick">批量修改</Button>
    <Table border :columns="Datacolumns" :data="Datalist" height="450" stripe>
        <!-- <template slot-scope="{ row }" slot="name">
            <strong>{{ row.name }}</strong>
        </template> -->
        <template slot-scope="{ row, index }" slot="action">
            <!-- <Button type="primary" size="small" style="margin-right: 5px" @click="show(index)">编辑</Button> -->
            <Button type="error" size="small" @click="remove(index)">删除</Button>
        </template>
    </Table>
  </div>
</template>

<script>
export default {
  name: 'PriceTable',
  props: {
    Datacolumns: Array,
    Datalist: Array
  },
  data () {
    return {

    }
  },
  methods: {
    // show (index) {
    //   this.$Modal.info({
    //     title: 'User Info',
    //     content: `Name：${this.data6[index].name}<br>Age：${this.data6[index].age}<br>Address：${this.data6[index].address}`
    //   })
    // },
    remove (index) {
      // this.data6.splice(index, 1)
      this.$Modal.confirm({
        title: '删除规则',
        content: '<p>确定删除这条数据？</p>',
        onOk: () => {
          this.DeletePriceData(index)
        }
      })
    },
    // 点击新增按钮触发事件
    NewBuildHandleClick () {
      this.$emit('NewBuildHandleClick')
    },
    // 删除回调
    DeletePriceData (index) {
      this.$emit('DeletePriceData', index)
    },
    // 点击批量修改按钮回调
    BatchHandleClick () {
      this.$emit('BatchHandleClick', true)
    }
  }
}
</script>
